<template>
  <div class="container" style="height: 100vh;overflow: hidden;overflow-y: auto;">
    <div class="hotsell_title">
      <img class="hotsell_title_bg" src="../../../assets/images/activity/miaosha/spike_benefits_topimage.png" />


      <div v-show="acticityTime==0">
        <div class="hotsell_tip" v-if="timeCount.timeData">本轮活动&nbsp;距结束{{timeCount.timeData.lefttime}}</div>
        <div class="hotsell_tip" v-else>本轮活动 {{activityTime}}</div>
      </div>
      <div v-show="acticityTime==1"class="hotsell_tip">{{next_times_activity}}</div>
      <!-- {{timeCount.timeData.lefttime}} -->
      <!-- <div class="hotsell_tip">本轮活动 已结束</div>
      <div class="hotsell_tip">本轮活动 距结束01:01:01</div>
      <div class="hotsell_tip">本轮活动 已抢完</div> -->
    </div>
    <div class="hotsell_cot" v-show="loaded">
      <div class="hotsell_cot_title">
        <div @click="switchOrderStatus(0)" :class="[{'hotsell_cot_title_item_active':orderStatus==0},'hotsell_cot_title_item']">今日下场</div>
        <!-- <div @click="switchOrderStatus(1)" :class="[{'hotsell_cot_title_item_active':orderStatus==1},'hotsell_cot_title_item']">明日下场</div> -->
        <div class="hotsell_cot_title_draw">
          <van-dropdown-menu active-color="#928156">
            <van-dropdown-item v-model="dropValue"  @change="dropChange" :options="dropOption" />
          </van-dropdown-menu>
        </div>
        <div class="clearn"></div>
      </div>
      <div class="hotsell_cot_today" v-show="orderStatus==0">
        <div v-show="todayStadium.length>0">
          <div class="hotsell_cot_list" v-for="(item,index) in todayStadium" v-show="item.city==dropCity||dropCity=='全国'">
            <div class="hotsell_cot_list_block">
              <img class="hotsell_cot_list_block_thumb" @click="toReserve_th(2,item.stadium_id,item)" :src="item.thumb" />
              <div class="hotsell_cot_list_block_item">
                <div class="hotsell_cot_list_block_item_icon"></div>
                <div class="hotsell_cot_list_block_item_text">
                  <div class="hotsell_cot_list_block_item_text_line">
                    黄金会员 <label class="hotsell_cot_list_block_item_text_line_nor">¥{{item.seckill_info.vip_gold_fee}}</label>
                    <label class="hotsell_cot_list_block_item_text_line_norPadding">/</label>
                    铂金会员 <label class="hotsell_cot_list_block_item_text_line_nor">¥{{item.seckill_info.vip_pt_fee}}</label>
                  </div>
                  <div class="hotsell_cot_list_block_item_text_line">
                    钻石会员&nbsp;&nbsp; <label class="hotsell_cot_list_block_item_text_line_nor">¥{{item.seckill_info.vip_diamond_fee}}</label>
                    <!-- <label class="hotsell_cot_list_block_item_text_line_norPadding">/</label>
                    <label style="text-decoration: line-through;color: #c7c6cc;">
                    &nbsp;门市价&nbsp;&nbsp;&nbsp; <label class="hotsell_cot_list_block_item_text_line_unnor" style="color: #c7c6cc;">¥{{(item.origin_price/100).toFixed(2)}}</label>
                    </label> -->
                  </div>
                </div>
                <div class="clearn"></div>
              </div>
              <div class="hotsell_cot_list_block_posi">{{item.realcity}}</div>
              <!--
               var dis=''
               if (s*1000<=100){
                 dis='<100米'
               } else if (s * 1000 < 1000){
                 dis = s * 1000+'米'
               }else{
                 dis = s.toFixed(1)+'km'
               }
               return dis
               -->
              <div class="hotsell_cot_list_distance" v-show="item.distancevarus != -1 &&item.distancevarus != 'NANkm'">{{item.distancevarus}}</div>
            </div>
            <div class="hotsell_cot_list_pos">
              <div class="hotsell_cot_list_pos_icon"></div>
              {{item.address}}
            </div>
            <div class="hotsell_cot_list_sub">
              <div v-show="item.seckill_info.now_status==1" class="hotsell_cot_list_sub_over" @click="toCreateOrder(item,'today')">未开始</div>
              <div v-show="item.seckill_info.now_status==2" class="hotsell_cot_list_sub_over" @click="toCreateOrder(item,'today')">已结束</div>
              <!--   -->
              <div v-show="item.seckill_info.now_status==3" :class="[{'hotsell_cot_list_sub_overingM':buttonTxt=='开通会员参与秒杀'},'hotsell_cot_list_sub_overing']" @click="toCreateOrder(item,'today')">
                {{buttonTxt}}
                <!-- <label>&nbsp;</label> -->
              </div>
              <div v-show="item.seckill_info.now_status==4" class="hotsell_cot_list_sub_over" @click="toCreateOrder(item,'today')">已抢完</div>
            </div>
          </div>
        </div>
        <div v-show="todayStadium.length==0" class="hotsell_cot_tomorrow_empty">
          <img class="hotsell_cot_tomorrow_emptyimg" src="../../../assets/images/base/emptylist.png" />
          <div class="hotsell_cot_tomorrow_emptytitle">暂无酒店</div>
          <div class="hotsell_cot_tomorrow_emptycont">因新冠病毒疫情和政策法规，该地区酒店健身、瑜伽服务将逐渐开放预约</div>
        </div>
      </div>
      <div class="hotsell_cot_tomorrow" v-show="orderStatus==1">
        <div v-show="tomorrowStadium.length>0">
          <div class="hotsell_cot_list" v-for="(item,index) in tomorrowStadium" v-show="item.city==dropCity||dropCity=='全国'">
            <div class="hotsell_cot_list_block">
              <img class="hotsell_cot_list_block_thumb" @click="toReserve_th(2,item.stadium_id,item)" :src="item.thumb" />
              <div class="hotsell_cot_list_block_item">
                <div class="hotsell_cot_list_block_item_icon"></div>
                <div class="hotsell_cot_list_block_item_text">
                  <div class="hotsell_cot_list_block_item_text_line">
                    黄金会员 <label class="hotsell_cot_list_block_item_text_line_nor">¥{{item.seckill_info.vip_gold_fee}}</label>
                    <label class="hotsell_cot_list_block_item_text_line_norPadding">/</label>
                    铂金会员 <label class="hotsell_cot_list_block_item_text_line_nor">¥{{item.seckill_info.vip_pt_fee}}</label>
                  </div>
                  <div class="hotsell_cot_list_block_item_text_line">
                    钻石会员&nbsp;&nbsp; <label class="hotsell_cot_list_block_item_text_line_nor">¥{{item.seckill_info.vip_diamond_fee}}</label>
                    <!-- <label class="hotsell_cot_list_block_item_text_line_norPadding">/</label>
                    <label style="text-decoration: line-through;color: #c7c6cc;">
                    &nbsp;门市价&nbsp;&nbsp;&nbsp; <label class="hotsell_cot_list_block_item_text_line_unnor" style="color: #c7c6cc;">¥{{(item.origin_price/100).toFixed(2)}}</label>
                    </label> -->
                  </div>
                </div>
                <div class="clearn"></div>
              </div>
              <div class="hotsell_cot_list_block_posi">{{item.realcity}}</div>
              <div class="hotsell_cot_list_distance" v-show="item.distancevarus != -1&&item.distancevarus != 'NANkm'">{{item.distancevarus}}</div>
            </div>
            <div class="hotsell_cot_list_pos">
              <div class="hotsell_cot_list_pos_icon"></div>
              {{item.address}}
            </div>
            <div class="hotsell_cot_list_sub">
              <div v-show="item.seckill_info.now_status==1" class="hotsell_cot_list_sub_over" @click="toCreateOrder(item,'tomorrow')">未开始</div>
              <div v-show="item.seckill_info.now_status==2" class="hotsell_cot_list_sub_over" @click="toCreateOrder(item,'tomorrow')">已结束</div>
               <!--  -->
              <div v-show="item.seckill_info.now_status==3" :class="[{'hotsell_cot_list_sub_overingM':buttonTxt=='开通会员参与秒杀'},'hotsell_cot_list_sub_overing']" @click="toCreateOrder(item,'tomorrow')">
                {{buttonTxt}}
                <!-- <label>&nbsp;</label> -->
              </div>
              <div v-show="item.seckill_info.now_status==4" class="hotsell_cot_list_sub_over" @click="toCreateOrder(item,'tomorrow')">已抢完</div>
            </div>
          </div>
        </div>
        <div v-show="tomorrowStadium.length==0" class="hotsell_cot_tomorrow_empty">
          <img class="hotsell_cot_tomorrow_emptyimg" src="../../../assets/images/base/emptylist.png" />
          <div class="hotsell_cot_tomorrow_emptytitle">暂无酒店</div>
          <div class="hotsell_cot_tomorrow_emptycont">因新冠病毒疫情和政策法规，该地区酒店健身、瑜伽服务将逐渐开放预约</div>
        </div>
      </div>
    </div>
    <div class="hotsell_floatIcon" v-show="floatIcon">
      <img src="../../../assets/images/activity/miaosha/1.png" @click="toimdex()" />
      <img v-show="floatIcon_vip" src="../../../assets/images/activity/miaosha/2.png" @click="tovip()" />
    </div>
  </div>
</template>

<script>
  import {
    isPhone,
    safeTel
  } from "../../../lib/utils.js"
  export default {
    data() {
      return {
        todayStadium:[],//今日酒店列表
        tomorrowStadium:[],//明日酒店列表
        todayCity:[{text:'全国',value:0}],//今日酒店城市
        tomorrowCity:[{text:'全国',value:0}],//明日酒店城市
        orderStatus:0,

        dropValue:0,
        dropOption:[],
        dropCity:'全国',

        userPayStatus:0,//0：游客，1黄金，2：铂金，3：钻石

        activityTime:'',
        timeCount:{},
        timeCountS:0,
        timerL:null,
        timerM:null,
        timerN:null,

        acticityTime:0,
        next_times_activity:'',

        floatIcon:false,
        floatIcon_vip:false,

        loaded:false,
        buttonTxt:'立即抢'
      }
    },
    created() { },
    mounted() {
      // this.isLogin()
    },
    activated() {
      this.getJsAuth()
      clearInterval(this.timerL);
      clearInterval(this.timerM)
      if(sessionStorage.getItem('hotsellLoad')=='yes'){
        sessionStorage.removeItem('hotsellLoad')
      }else{
        this.isLogin()
      }
      this.getCurrentTime()
      this.nextTimes()
    },
    methods: {
      toReserve_th(item,id,all){
        // console.log(all)
        // console.log(all.seckill_info.now_status)
        if(all.seckill_info.now_status==3){
          // console.log('保留')
        }else{

          // this.$router.push({
          //   name:'resdetail',
          //   params:{
          //     stadium_id:all.stadium_id
          //   }
          // })


        }

      },
      toimdex(){
        this.$router.push({
          name:'index'
        })
      },
      tovip(){
        this.$router.push({
          name:'vip'
        })
      },
      getJsAuth() {

        let that = this;
        var param = {
          url: location.href.split('#')[0]
        }
        var qs = require('qs');
        let url = this.api.userApi.getJsAuth
        this.axios.post(url, qs.stringify(param), )
        .then((res) => {
          // console.log(res)
          wx.config({
            debug: false,
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: [
              'getLocation',
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
            ]
          });
          wx.ready(function() {
            that.sharecurr()
          });
        }).catch((error) => {
          console.warn(error)
          // that.$toast(error);
        })

      },
      sharecurr(){
        let that = this
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: '斐燃生活超值秒杀活动', // 分享标题
            desc: '五星级酒店游泳健身限时超值秒杀，名额有限抢完为止', //分享描述
            link: window.location.href, // 分享链接
            imgUrl: 'http://img.unionfit.cn/seckill_share.png', // 分享图标
            success() {
              // console.log('分享给朋友 旧')
            },
            fail(){
              // console.log('分享给朋友 失败')
            }
          });
          wx.updateTimelineShareData({
            title: '斐燃生活超值秒杀活动', // 分享标题
            // desc: '五星级酒店游泳健身限时超值秒杀，会员仅需8元起，名额有限抢完为止', //分享描述
            link: window.location.href, // 分享链接
            imgUrl: 'http://img.unionfit.cn/seckill_share.png', // 分享图标
            success: function () {
              // 设置成功
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: '斐燃生活超值秒杀活动', // 分享标题
            desc: '五星级酒店游泳健身限时超值秒杀，名额有限抢完为止', //分享描述
            link: window.location.href, // 分享链接
            imgUrl: 'http://img.unionfit.cn/seckill_share.png', // 分享图标
            success(res) {
              // console.log(res)
            }
          });
          wx.onMenuShareTimeline({
            title: '斐燃生活超值秒杀活动', // 分享标题
            // desc: '五星级酒店游泳健身限时超值秒杀，会员仅需8元起，名额有限抢完为止', //分享描述
            link: window.location.href, // 分享链接
            imgUrl: 'http://img.unionfit.cn/seckill_share.png', // 分享图标
            success: function () {
              // 设置成功
            }
          });
        }
      },
      nextTimes(){
        var day3 = new Date();
        day3.setTime(day3.getTime()+24*60*60*1000);
        this.next_times_activity = '下一轮开始 '+ (day3.getMonth()+1) + '月' + day3.getDate()+'日  09:00:00';
        // console.log(s3)
      },
      getCurrentTime(){
        var $this=this
        var date=new Date();
        var hh=date.getHours();
        // console.log(hh)
        if(hh<9){
          this.activityTime='09:00:00开始'
          this.timeCountS=0
          if(hh>8){
            // timerN
            var $this=this
            this.timerN=setInterval(function(){
              $this.getCurrentTime()
              $this.getHotsellStadium()
              var datem=new Date();
              var hhm=datem.getHours();
              // console.log(123)
              if(hhm>=9){
                clearInterval($this.timerN)
              }
            },1000)
          }
        }else if(hh<=24){
          this.activityTime='活动进行中'
          /**
           // 时间格式必须为  YYYY-MM-DD HH:MM:SS  或者 YYYY-MM-DD
           let start_time  = "2017-05-08 12:50:30";
           new Date(start_time).getTime()  // 使用上面三种均可以实现
           */
          var date = new Date();
          var dateY=date.getFullYear();
          var dateM=date.getMonth()+1;
          if(dateM<10){dateM='0'+dateM}
          var dateD=date.getDate();
          if(dateD<10){dateD='0'+dateD}
          // console.log(dateY+'-'+dateM+'-'+dateD+' 14:00:00')
          var start_time=dateY+'/'+dateM+'/'+dateD+' 14:00:00'
          var spe_date = new Date(start_time).getTime()
          var remainTime=new Date(spe_date) - (new Date().getTime());
          if(remainTime>0){
            this.timerL=setInterval(function(){
              var remainTimeD=new Date(spe_date) - (new Date().getTime());
              var hourse ='0'+parseInt(remainTimeD / (60000 * 60),10)
              // console.log(remainTimeD)
              // console.log(hourse)
              var minutes = parseInt(remainTimeD / 1000 / 60 % 60, 10);
              if (minutes<10){minutes = '0' + minutes}
              //计算剩余的秒数
              var seconds = parseInt(remainTimeD / 1000 % 60, 10);
              if (seconds < 10) { seconds = '0' + seconds }
              var left_time =hourse + ":" + minutes + ":" + seconds;
              if(seconds=='00'||seconds==10||seconds==20||seconds==30||seconds==40||seconds==50){
                // console.log('更新数据')
                $this.getHotsellStadium()
              }
              // this.left_time=left_time
              // console.log(this.left_time)
              // console.log(left_time)
              $this.timeCountS=1
              $this.$set($this.timeCount,'timeData',{
                lefttime:left_time
              })
              if(left_time=="00:01:00"){
                $this.getCutDown()
                // console.log('11')
              }
              if(left_time=="00:00:00"){
                clearInterval($this.timerL)
                // $this.$router.go(0);
                // console.log('22')
                $this.getHotsellStadium()
                clearInterval($this.timerM)
                $this.getCutDown()
              }
            },1000)
          }else{
            this.activityTime='已结束'
            this.timeCountS=0
            this.acticityTime=1
          }
        }else{
          this.activityTime='已结束.'
          this.timeCountS=0
          this.acticityTime=1
        }
      },
      // 重新来个一分钟倒计时，防止服务器时间与用户端时间不一致
      getCutDown(){
        var $this = this
        var date = new Date();
        var dateY=date.getFullYear();
        var dateM=date.getMonth()+1;
        if(dateM<10){dateM='0'+dateM}
        var dateD=date.getDate();
        if(dateD<10){dateD='0'+dateD}
        var start_time=dateY+'/'+dateM+'/'+dateD+' 14:01:00'
        var spe_date = new Date(start_time).getTime()
        var remainTime=new Date(spe_date) - (new Date().getTime());
        // console.log(remainTime)
        if(remainTime>0){
          $this.timerM=setInterval(function(){
            $this.getHotsellStadium()
            // console.log('33')
            var lasttim=new Date(spe_date) - (new Date().getTime());
            if(lasttim<0){
              clearInterval($this.timerM)
            }
          },1000)
        }else{
          // console.log('44')
          clearInterval($this.timerM)
        }
      },
      // 计算两个经纬度之间的距离
      distance(la1, lo1, la2, lo2){
        var La1 = la1 * Math.PI / 180.0;
        var La2 = la2 * Math.PI / 180.0;
        var La3 = La1 - La2;
        var Lb3 = lo1 * Math.PI / 180.0 - lo2 * Math.PI / 180.0;
        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(La3 / 2), 2) + Math.cos(La1) * Math.cos(La2) * Math.pow(Math.sin(Lb3 / 2), 2)));
        s = s * 6378.137;//地球半径
        s = Math.round(s * 10000) / 10000;
        // console.log("计算结果", s)
        var dis=''
        if (s*1000<=100){
          dis='<100米'
        } else if (s * 1000 < 1000){
          dis = (s * 1000).toFixed(1)+'米'
        }else{
          dis = s.toFixed(1)+'km'
        }
        return dis
      },
      // 计算两个经纬度之间的距离
      distanceMore(la1, lo1, la2, lo2){
        var La1 = la1 * Math.PI / 180.0;
        var La2 = la2 * Math.PI / 180.0;
        var La3 = La1 - La2;
        var Lb3 = lo1 * Math.PI / 180.0 - lo2 * Math.PI / 180.0;
        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(La3 / 2), 2) + Math.cos(La1) * Math.cos(La2) * Math.pow(Math.sin(Lb3 / 2), 2)));
        s = s * 6378.137;//地球半径
        s = Math.round(s * 10000) / 10000;
        // console.log("计算结果", s)
        return s
      },
      isLogin(){
        if(localStorage.getItem("token")){
          this.getHotsellStadium()
          this.getUserCard()
          this.floatIcon=true
          /**
           floatIcon:false,
           floatIcon_vip:false
           */
        }else{
          // this.$router.push({
          //   name:'login'
          // })
          this.floatIcon=true
          this.getHotsellStadium()
        }
      },
      getUserCard(){
        var $this = this
        let param = {
          token: localStorage.getItem("token"),
        }
        var qs = require('qs');
        let url = this.api.userApi.flUserCardsList
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.data) {
            if(result.data.length==0){
              $this.userPayStatus=0
              $this.floatIcon_vip=true
            }else{
              $this.floatIcon_vip=false
              // userPayStatus:0,//0：游客，1黄金，2：铂金，3：钻石
              for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].vip_tag=='A1'||result.data[i].vip_tag=='A2'){
                  $this.userPayStatus=1
                }
              }
              for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].vip_tag=='B1'||result.data[i].vip_tag=='B2'){
                  $this.userPayStatus=2
                }
              }
              for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].vip_tag=='C1'||result.data[i].vip_tag=='C2'){
                  $this.userPayStatus=3
                }
              }
            }
          } else {
            $this.floatIcon_vip=true
            $this.buttonTxt='开通会员参与秒杀'
            // $this.$toast(result.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })
      },
      distanceSort(obj1,obj2){
        var val1 = obj1.distanceActuraly;
        var val2 = obj2.distanceActuraly;
        if (val1 < val2) {
            return -1;
        } else if (val1 > val2) {
            return 1;
        } else {
            return 0;
        }
      },
      getHotsellStadium(){
        // console.log('几次？')
        this.getVipCardList()
        var $this = this
        $this.todayCity=[{text:'全国',value:0}]
        $this.tomorrowCity=[{text:'全国',value:0}]
        let param = {
          token: localStorage.getItem("token"),
        }
        var qs = require('qs');
        let url = this.api.userApi.getSeckillStadiums
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.data) {
            $this.loaded=true
            for (var i = 0; i < result.data.today.length; i++) {
              if(localStorage.getItem('curPosition')){
                var cp=JSON.parse(localStorage.getItem('curPosition'))
                result.data.today[i].distancevarus=$this.distance(cp.latitude,cp.longitude,result.data.today[i].latitude,result.data.today[i].longitude,)
                result.data.today[i].distanceActuraly=$this.distanceMore(cp.latitude,cp.longitude,result.data.today[i].latitude,result.data.today[i].longitude)
              }else{
                result.data.today[i].distancevarus=-1
                result.data.today[i].distanceActuraly=0
              }
              result.data.today[i].realcity=(result.data.today[i].city).substring(0,(result.data.today[i].city).length-1)
            }
            for (var i = 0; i < result.data.tomorrow.length; i++) {
              if(localStorage.getItem('curPosition')){
                var cp=JSON.parse(localStorage.getItem('curPosition'))
                result.data.tomorrow[i].distancevarus=$this.distance(cp.latitude,cp.longitude,result.data.tomorrow[i].latitude,result.data.tomorrow[i].longitude,)
                result.data.tomorrow[i].distanceActuraly=$this.distanceMore(cp.latitude,cp.longitude,result.data.tomorrow[i].latitude,result.data.tomorrow[i].longitude)
              }else{
                result.data.tomorrow[i].distancevarus=-1
                result.data.tomorrow[i].distanceActuraly=0
              }
              result.data.tomorrow[i].realcity=(result.data.tomorrow[i].city).substring(0,(result.data.tomorrow[i].city).length-1)
            }

            (result.data.today).sort(function (obj1, obj2) {
              var val1 = obj1.distanceActuraly;
              var val2 = obj2.distanceActuraly;
              // console.log('sort')
              if (val1 < val2) {
                return -1;
              } else if (val1 > val2) {
                return 1;
              } else {
                return 0;
              }
            });

            var todaysorttemp=[];
            for (var i = 0; i < result.data.today.length; i++) {
              // console.log('now_status')
              if(result.data.today[i].seckill_info.now_status==3){
                todaysorttemp.push(result.data.today[i])
                result.data.today.splice(i,1)
                i--
              }
            }

            var Atodaysorttemp=[]
            if(todaysorttemp.length==0){
              Atodaysorttemp=result.data.today
            }else{
              // Atodaysorttemp = todaysorttemp.concat(result.data.today)
              if(result.data.today.length==0){
                Atodaysorttemp = todaysorttemp
              }else{
                Atodaysorttemp = todaysorttemp.concat(result.data.today)
              }
            }

            (result.data.tomorrow).sort(function (obj1, obj2) {
              var val1 = obj1.distanceActuraly;
              var val2 = obj2.distanceActuraly;
              if (val1 < val2) {
                return -1;
              } else if (val1 > val2) {
                return 1;
              } else {
                return 0;
              }
            });
            // console.log(result.data.tomorrow);
            var tomorrowsorttemp=[]
            for (var i = 0; i < result.data.tomorrow.length; i++) {
              if(result.data.tomorrow[i].seckill_info.now_status==3){
                tomorrowsorttemp.push(result.data.tomorrow[i])
                result.data.tomorrow.splice(i,1)
                i--
              }
            }

            var Atomorrowsorttemp=[]
            // console.log(result.data.tomorrow);
            if(tomorrowsorttemp.length==0){
              Atomorrowsorttemp=result.data.tomorrow
            }else{
              // console.log(tomorrowsorttemp)
              // console.log(result.data.tomorrow)

              if(result.data.tomorrow.length==0){
                Atomorrowsorttemp = tomorrowsorttemp
              }else{
                Atomorrowsorttemp = tomorrowsorttemp.concat(result.data.tomorrow)
              }
              // Atomorrowsorttemp = Atomorrowsorttemp.concat(result.data.tomorrow)
            }

            $this.todayStadium=Atodaysorttemp//result.data.today
            $this.tomorrowStadium=Atomorrowsorttemp//result.data.tomorrow
            var temptoday=[]
            var temptomorrow=[]
            for (var i = 0; i < Atodaysorttemp.length; i++) {
              temptoday.push(Atodaysorttemp[i].city)
            }
            var tmp = [];
            for(var i in temptoday){
              if(tmp.indexOf(temptoday[i])==-1){
                tmp.push(temptoday[i]);
              }
            }
            // console.log(tmp)
            temptoday=tmp
            for (var i = 0; i < Atomorrowsorttemp.length; i++) {
              temptomorrow.push(Atomorrowsorttemp[i].city)
            }
            var tmpt = [];
            for(var i in temptomorrow){
              if(tmpt.indexOf(temptomorrow[i])==-1){
                tmpt.push(temptomorrow[i]);
              }
            }
            // console.log(tmpt)
            temptomorrow=tmpt
            // console.log(temptoday)
            // console.log(temptomorrow)
            for (var i = 0; i < temptoday.length; i++) {
              var j=i+1
              var param={
                text:temptoday[i],
                value:j
              }
              $this.todayCity.push(param)
            }
            for (var i = 0; i < temptomorrow.length; i++) {
              var j=i+1
              var param={
                text:temptomorrow[i],
                value:j
              }
              $this.tomorrowCity.push(param)
            }
            // console.log($this.todayCity)
            // console.log($this.tomorrowCity)
            $this.dropOption=$this.todayCity
          } else {
            // $this.$toast(result.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
          $this.loaded=true
        });
      },
      getVipCardList(){
        if(localStorage.getItem("token")){
          var $this = this
          let paramss = {
            token: localStorage.getItem("token"),
          }
          var qs = require('qs');
          let url = this.api.userApi.flUserCardsList
          this.axios.post(url, qs.stringify(paramss), )
          .then((result) => {
            console.log(result)
            if (result.data) {
              if(result.data.length==0){
                $this.buttonTxt='开通会员参与秒杀'
              }else{
                $this.buttonTxt='立即抢'
              }
            } else {
              // $this.$toast('result.msg');
              // $this.$toast(result.msg);
            }
          }).catch((error) => {
            console.warn(error)
            // $this.$toast('error');
          })
        }
      },
      switchOrderStatus(item){
        // console.log(item)
        this.orderStatus=item
        if(item==0){
          this.dropOption=this.todayCity
        }else{
          this.dropOption=this.tomorrowCity
        }
        this.dropValue=0
        this.dropCity='全国'
      },
      dropChange(e){
        // console.log(e)
        for (var i = 0; i < this.dropOption.length; i++) {

          if(this.dropOption[i].value==e){
            // console.log(this.dropOption[i])
            this.dropCity=this.dropOption[i].text
          }
        }
      },
      toCreateOrder(item,datatype){
        // console.log(item.seckill_info)
        // console.log(this.userPayStatus)
        // console.log(datatype)
        // =============

        // ==============

        // var param={
        //   userPayStatus:this.userPayStatus,
        //   datatype:datatype,
        //   stadium:item.stadium_id
        // }
        // sessionStorage.setItem('hotsellParam',JSON.stringify(param))
        // sessionStorage.setItem('hotsell_create',JSON.stringify(item.seckill_info))
        // this.$router.push({
        //   name:'hotsellcreate'
        // })
        // return

        if(item.seckill_info.now_status==3){
          if(localStorage.getItem("token")){
            var $this = this
            var param={
              userPayStatus:this.userPayStatus,
              datatype:datatype,
              stadium:item.stadium_id
            }
            $this.$loading('正在前往')
            sessionStorage.setItem('hotsellParam',JSON.stringify(param))
            sessionStorage.setItem('hotsell_create',JSON.stringify(item.seckill_info))
            let paramss = {
              token: localStorage.getItem("token"),
            }
            var qs = require('qs');
            let url = this.api.userApi.flUserCardsList
            this.axios.post(url, qs.stringify(paramss), )
            .then((result) => {
              console.log(result)
              if (result.data) {
                if(result.data.length>0){
                  $this.isBlackList(item.stadium_id)
                }else{
                  $this.$loading.close()
                  $this.$router.push({
                    name:'vip'
                  })
                  // $this.$dialog.alert({
                  //   title: '温馨提示',
                  //   message: "成为《斐燃会员》即可参与该秒杀活动~",
                  //   confirmButtonColor: '#544590'
                  // }).then(() => {
                  //   $this.$router.push({
                  //     name:'vip'
                  //   })
                  // })
                }
              } else {
                $this.$loading.close()
                $this.$router.push({
                  name:'vip'
                })
              }
            }).catch((error) => {
              $this.$loading.close()
              console.warn(error)
              // $this.$toast('error');
            })
          }else{
            this.$router.push({
              name:'login'
            })
          }
        }else if(item.seckill_info.now_status==1){
          this.$toast('活动未开始，请稍后');
        }else if(item.seckill_info.now_status==2){
          this.$toast('此次活动已结束，后续活动更精彩');
        }else if(item.seckill_info.now_status==4){
          this.$toast('该酒店已抢完，可以试试其他酒店');
        }else{
          this.$toast('活动已结束');
        }
        // 1 未开始 2已结束 3进行中 4已抢完
      },
      // 判断用户是否在黑名单中
      isBlackList(stadium_id){
        var $this = this
        var param={
          token: localStorage.getItem("token"),
          stadium_id:stadium_id
        }
        var qs = require('qs');
        let url = this.api.userApi.getBlacklist
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // console.log(res)
          $this.$loading.close()
          if (res.data) {
            if(res.data.is_in_blacklist==0){
              $this.$router.push({
                name:'hotsellcreate'
              })
            }else{
              $this.$toast('抱歉，您暂时无法使用该健身礼遇，请详询客服服务热线。')
            }
          } else {
            $this.$toast(res.msg)
          }
        }).catch((error) => {
          $this.$loading.close()
          console.warn(error)
          $this.$toast(res.msg);
        })


      }
    },
    destroyed: function() {
      clearInterval(this.timerL);
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .clearn{
    clear: both;
  }
  .container{
    background: #ffffff;
  }
  .hotsell_floatIcon{
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom: 200*@vm_base;
    margin-right: 12*@vm_base;
    z-index: 999;
    img{
      width: 136*@vm_base;
      margin-bottom: -20*@vm_base;
      // margin-top: 20*@vm_base;
    }
  }
  .hotsell_title{
    width: 100%;
    position: relative;
    .hotsell_title_bg{
      width: 100%;
    }
    .hotsell_tip{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 32*@vm_base;
      font-weight: 500;
      color: #000000;
      margin-bottom: 84*@vm_base;
    }
  }
  .hotsell_cot{
    padding: 12*@vm_base 32*@vm_base 0 32*@vm_base;
    .hotsell_cot_title{
      width: 100%;
      .hotsell_cot_title_item{
        float: left;
        width: 420*@vm_base;
        text-align: center;
        font-size: 28*@vm_base;
        font-weight: 500;
        padding: 24*@vm_base 0;
        background: #F5F5F5;
        color: #999999;
        border-radius: 6*@vm_base;
      }
      .hotsell_cot_title_item_active{
        background: #282828;
        color: #FFFFFF;
        border-radius: 4*@vm_base;
      }
      .hotsell_cot_title_draw{
        float: right;
        width: 240*@vm_base;
        height: 86*@vm_base;
        background: #F5F5F5;
        border-radius: 6*@vm_base;
      }
    }
    .hotsell_cot_list{
      width: 100%;
      padding: 42*@vm_base 0 0 0;
      border-bottom: 1*@vm_base solid #EBEBEB;
      .hotsell_cot_list_block{
        width: 100%;
        height: 486*@vm_base;
        position: relative;
        display: flex;
        justify-content: center;
        // overflow: hidden;
        .hotsell_cot_list_block_thumb{
         height: 428*@vm_base;
        }
        .hotsell_cot_list_block_item{
          width: calc(100% - 46*@vm_base);
          position: absolute;
          bottom: 0;
          right: 0;
          margin-right: -1px;
          height: 128*@vm_base;
          background: #FFFFFF;
          box-shadow: 0px 10*@vm_base 30*@vm_base 0px rgba(9, 9, 9, 0.1);
          z-index: 1;
          padding: 20*@vm_base;
          .hotsell_cot_list_block_item_icon{
            width: 210*@vm_base;
            height: 88*@vm_base;
            float: left;
            background-image: url(../../../assets/images/activity/miaosha/icon.png);
            background-size: 131*@vm_base auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          .hotsell_cot_list_block_item_text{
            height: 88*@vm_base;
            position: absolute;
            right: 0;
            margin-right: 20*@vm_base;
            float: right;
            .hotsell_cot_list_block_item_text_line{
              width: 100%;
              text-align: right;
              height: 44*@vm_base;
              line-height: 44*@vm_base;
              font-size: 24*@vm_base;
              color: #666666;
              .hotsell_cot_list_block_item_text_line_nor{
                color: #928156;
              }
              .hotsell_cot_list_block_item_text_line_unnor{
                color: #666666;
              }
              .hotsell_cot_list_block_item_text_line_norPadding{
                display: inline-block;
                padding: 0 10*@vm_base;
              }
            }
          }
        }
        .hotsell_cot_list_block_posi{
          position: absolute;
          bottom: 0;
          left: 0;
          margin-bottom: 58*@vm_base;
          padding: 13*@vm_base 21*@vm_base;
          z-index: 2;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: #FFFFFF;
          background: rgba(0, 0, 0, 0.85);
        }

      }
      .hotsell_cot_list_pos{
        width: 100%;
        padding: 30*@vm_base 0 0 46*@vm_base;
        font-size: 24*@vm_base;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #666666;
        .hotsell_cot_list_pos_icon{
          width: 18*@vm_base;
          height: 32*@vm_base;
          float: left;
          background-image: url(../../../assets/images/activity/miaosha/posi.png);
          background-position: center;
          background-size: 18*@vm_base 24*@vm_base;
          background-repeat: no-repeat;
          float: left;
          margin-right: 12*@vm_base;
        }
      }
      .hotsell_cot_list_sub{
        width: 100%;
        padding: 40*@vm_base 0 60*@vm_base 0;
        .hotsell_cot_list_sub_over{
          width: 100%;
          padding: 29*@vm_base 0;
          background: #F3F3F3;
          color: #444054;
          // background: #282828;
          // color: #FFFFFF;
          border-radius: 12*@vm_base;
          text-align: center;
          font-size: 32*@vm_base;
          font-weight: 500;

          letter-spacing: 2*@vm_base;

        }
        .hotsell_cot_list_sub_overing{
          width: 100%;
          padding: 29*@vm_base 0;
          background: #282828;
          border-radius: 12*@vm_base;
          text-align: center;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          letter-spacing: 2*@vm_base;
          label{
            display: inline-block;
            width: 54.28*@vm_base;
            background-image: url(../../../assets/images/activity/miaosha/arr.png);
            background-size: 34.28*@vm_base auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
        .hotsell_cot_list_sub_overingM{
          background:#E1C786
        }
      }
    }
    .hotsell_cot_today{
      width: 100%;
      overflow: hidden;
      .hotsell_cot_tomorrow_empty{
        width: 100%;
        .hotsell_cot_tomorrow_emptyimg{
          width: 263*@vm_base;
          margin: 0 auto;
          margin-top: 130*@vm_base;
        }
        .hotsell_cot_tomorrow_emptytitle{
          width: 100%;

          font-size: 28*@vm_base;
          font-weight: 500;
          color: #333333;
          text-align: center;
          padding: 20*@vm_base 0;

        }
        .hotsell_cot_tomorrow_emptycont{
          width: 100%;
          padding: 0 58*@vm_base 96*@vm_base 58*@vm_base;
          font-size: 24*@vm_base;
          font-weight: 500;
          color: #B4B3BB;
          line-height: 33*@vm_base;
          text-align: center;

        }
      }
    }
    .hotsell_cot_tomorrow{
      width: 100%;
      overflow: hidden;
      .hotsell_cot_tomorrow_empty{
        width: 100%;
        .hotsell_cot_tomorrow_emptyimg{
          width: 263*@vm_base;
          margin: 0 auto;
          margin-top: 130*@vm_base;
        }
        .hotsell_cot_tomorrow_emptytitle{
          width: 100%;

          font-size: 28*@vm_base;
          font-weight: 500;
          color: #333333;
          text-align: center;
          padding: 20*@vm_base 0;

        }
        .hotsell_cot_tomorrow_emptycont{
          width: 100%;
          padding: 0 58*@vm_base 96*@vm_base 58*@vm_base;
          font-size: 24*@vm_base;
          font-weight: 500;
          color: #B4B3BB;
          line-height: 33*@vm_base;
          text-align: center;

        }
      }
    }
    .hotsell_cot_list_distance{
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      font-size: 20*@vm_base;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 20*@vm_base;
      margin-right: 20*@vm_base;
      padding: 8*@vm_base 16*@vm_base;

      background: rgba(0, 0, 0, 0.3);
      border-radius: 18*@vm_base;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/limitedTime/hotsell.vue